import { DisposeAction } from './dispose-action.constants'
import type { DisposeActionType } from './dispose-action.constants'

/** 从威胁实体提取域名（URL 或 host/path） */
export function extractDomainFromThreat (entity: string): string {
  if (!entity) return ''
  try {
    if (/^https?:\/\//i.test(entity)) return new URL(entity).hostname
  } catch {
    /* ignore */
  }
  const slash = entity.indexOf('/')
  return slash > 0 ? entity.slice(0, slash) : entity
}

/** 生成策略名称：事件描述 + 后缀 + 时间戳 */
export function buildStrategyName (
  eventDesc: string,
  suffix: string,
): string {
  const base = (eventDesc || 'event').slice(0, 80).replace(/[/\\?#%&=]/g, '_')
  return `${base}_${suffix}_${Date.now()}`
}

export function isTrustAction (value: DisposeActionType) {
  return String(value).startsWith('trust_')
}

export function isStatusOnlyAction (value: DisposeActionType) {
  return (
    value === DisposeAction.MarkHandled || value === DisposeAction.MarkIgnored
  )
}

export function isFileContextAction (value: DisposeActionType) {
  return (
    value === DisposeAction.IsolateFile || value === DisposeAction.TrustFile
  )
}
